module.exports = __webpack_public_path__ + "static/media/04C.a5830762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/04C.png
// module id = 279
// module chunks = 0